export const CREATE_PHONE_ASYNC = 'create-phone-async';
export const PROMO_CODES = 'pr-di-ab-test';
